import type { JSX } from 'react'
import { cn } from '#src/cn.ts'

export function IconCircleCheck({
  className,
}: {
  className?: string
}): JSX.Element {
  return (
    <svg
      className={cn('size-4 shrink-0', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="#5E68D0"
      role="img"
      focusable="false"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.2803 6.78228C11.5732 6.48939 11.5732 6.01452 11.2803 5.72162C10.9874 5.42873 10.5126 5.42873 10.2197 5.72162L7.25 8.69129L5.78033 7.22162C5.48744 6.92873 5.01256 6.92873 4.71967 7.22162C4.42678 7.51452 4.42678 7.98939 4.71967 8.28228L6.71967 10.2823C7.01256 10.5752 7.48744 10.5752 7.78033 10.2823L11.2803 6.78228Z"></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 8.00195C15 11.8679 11.866 15.002 8 15.002C4.13401 15.002 1 11.8679 1 8.00195C1 4.13596 4.13401 1.00195 8 1.00195C11.866 1.00195 15 4.13596 15 8.00195ZM13.5 8.00195C13.5 11.0395 11.0376 13.502 8 13.502C4.96243 13.502 2.5 11.0395 2.5 8.00195C2.5 4.96439 4.96243 2.50195 8 2.50195C11.0376 2.50195 13.5 4.96439 13.5 8.00195Z"
      ></path>
    </svg>
  )
}
